import React from "react"
import Layout from "../layouts/Layout"
import Profile from "../components/Profile"

export default function index() {
  return (
    <Layout>
      <Profile />
    </Layout>
  )
}
